import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconToggleHeartOn12, IconFinancePercent12 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import * as styles from '../styles.css';

interface IGetIcon {
  isFavorite?: boolean;
  isPromo?: boolean;
  isActive?: boolean;
  isViewed?: boolean;
  isPromoBalloon?: boolean;
  isRedesign?: boolean;
}

export const getIcon = ({ isFavorite, isPromo, isActive, isViewed, isPromoBalloon, isRedesign }: IGetIcon) => {
  if (isFavorite) {
    let color: TColors;

    if (isRedesign) {
      color = isActive ? 'control-negative-primary-default' : 'control-inverted-primary-default';
    } else {
      color = isPromoBalloon && isActive ? 'icon-inverted-default' : 'icon-negative-default';
    }

    return renderToStaticMarkup(
      <div
        className={clsx(isActive && styles['favorite-icon--active'], isRedesign && styles['favorite-icon--redesign'])}
      >
        {createElement(IconToggleHeartOn12, { color })}
      </div>,
    );
  }

  if (isPromo) {
    let color: TColors = isViewed ? 'icon-primary-disabled' : 'icon-positive-default';
    if (isActive) {
      color = 'icon-inverted-default';
    }

    return renderToStaticMarkup(createElement(IconFinancePercent12, { color }));
  }

  return '';
};
